<template>
  <div>
    <!-- TEINTES -->
    <div class="component-container" @click="showTintsOptions = !showTintsOptions" v-if="defaultTints">
      <div class="component__select" @focusout="handleFocusOut">
        <span class="component__select--name">
          <span class="name">{{
            tint && tint.tint
              ? tint.tint.label.toUpperCase()
              : defaultTints
              ? defaultTints.tint.label.toUpperCase()
              : 'Choisir une teinte'
          }}</span>
          <RoundButton class="bordered button" width="18" v-if="showTintsOptions" image="ic-arrow-drop-down.svg" />
          <RoundButton class="bordered button" width="18" v-if="!showTintsOptions" image="ic-arrow-link.svg" />
        </span>

        <span class="c-arrow-down" v-if="!showTintsOptions"></span>
        <span class="c-arrow-up" v-if="showTintsOptions"></span>
      </div>

      <ul class="component__select-options" v-if="showTintsOptions">
        <li
          class="select--option"
          v-for="option in otherTintsOptions"
          v-bind:key="option.tint.label"
          @click="selectTintsOption(option)"
        >
          <label class="labelSelect">
            <input type="checkbox" :value="option" />
            <span class="color" :style="{ backgroundColor: option.tint.color }"></span>
            <span class="name">{{ option.tint.label.toUpperCase() }}</span>
          </label>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import RoundButton from '@Components/Menus/RoundButton.vue';
export default {
  components: {
    RoundButton,
  },
  props: ['options', 'value'],
  data: () => ({
    product: {},
    tint: {},
    showGlassOptions: false,
    showTintsOptions: false,
  }),
  methods: {
    // on selected tints
    selectTintsOption(option) {
      this.tint = option;
      var color = option.tint.color;

      if (document.querySelector('#filtre')) {
        document.querySelector('#filtre').style.backgroundColor = color;
      }
    },
    handleFocusOut() {
      this.showGlassOptions = false;
    },
    handleFocus() {
      this.showGlassOptions = true;
    },
  },
  mounted() {
    this.$log.debug('tint mounted');
    if (this.defaultTints) {
      var color = this.defaultTints.tint.color;
      setTimeout(() => {
        // Note: setTimeout fixes an IE bug
        if (document.querySelector('#filtre')) {
          document.querySelector('#filtre').style.backgroundColor = color;
        }
      });
    }
  },
  computed: {
    defaultTints() {
      var currentProduct = this.$store.getters.getProductByDemoId(this.$route.params.id);

      if (this.options.includes(currentProduct)) {
        return currentProduct.productTints[0];
      }

      return {};
    },

    otherTintsOptions() {
      var currentProduct = this.$store.getters.getProductByDemoId(this.$route.params.id);
      return currentProduct.productTints;
    },
  },
};
</script>

<style scoped>
.component__select--name {
  font-size: 0.8rem;
  padding: 0 0 0 25px;
  cursor: pointer;
  display: flex;
  align-items: center;
}
.button {
  margin-left: 5px;
}
.c-arrow-down {
  justify-self: end;
}

.name {
  font-size: 18px;
  color: black;
  letter-spacing: 0.5px;
  margin-left: 2px;
}
.component__select-options .name {
  font-size: 18px;
}
#glassesTintsSelect {
  display: flex;
}
.color {
  display: inline-block;
  width: 15px;
  height: 15px;
}
.component__select-options {
  cursor: pointer;
  background-color: white;
  margin: 0;
  position: absolute;
  bottom: 100%;
  text-align: center;
  width: 300px;
  padding: 0;
  padding-top: 15px;
}
.labelSelect {
  cursor: pointer;
}
.labelSelect:hover::after {
  content: '';
  padding-top: 4px;
  display: block;
  margin: auto;
  width: 200px;
  widows: 100px;
  text-align: center;
  border-bottom: 2px solid #5ebeb3;
}
.select--option {
  margin-bottom: 10px;
  height: 35px;
  align-content: center;
  list-style: none;
}

.select--option:last-child {
  border-bottom: none;
}
.component-container {
  width: 300px;
}
.select--option:nth-child(2n) {
  background-color: #ffffff;
}

.select--option input {
  display: none;
}
</style>
